<template>
    <div class="pop-recom" v-if="showQuitModal" v-cloak>
            <div class="pop-body" @click="preventDefault">
                <div class="title">
                    <p>温馨提示</p>
                </div>

                <div class="content">
                    <p>非常抱歉，本业务暂不支持办理，推荐办理更优惠产品: {{ productName }}</p>
                </div>

                <div class="button" @click="jump">点击查看{{time}}s</div>

                <!-- <div class="button" @click="closeRecomBox">不了，谢谢</div> -->
                
            </div>
        </div>
</template>

<script>
export default {
    name: 'RecomBox',
    props:['showQuitModal', 'productName', 'toUrl'],
    data(){
        return {
            time: 3
        }
    },
    created(){
        
    },
    mounted(){
        
    },
    watch:{
        showQuitModal(now, old) {
            if(now){
                this.timer();
            }

            if(old){
                var _this = this;
                _this.time = 3;
            }
        },
        time(now, old){
            var _this = this;
            if(now == 0 && _this.showQuitModal){
                
            } else {

            }
        }
    },
    methods: {
        toFreeGet(){
            window.location.href=this.toUrl;
        },
        preventDefault(e) {
            e.stopPropagation()
        },
        closeRecomBox(){
            this.$emit("closeRecomBox");
        },
        jump(){
            window.location.href = this.toUrl;
        },
        timer(){
            var _this = this;
            var t = setInterval(() => {
                if (_this.time > 0) {
                    _this.time--
                } else {
                    clearInterval(t);
                    window.location.href = _this.toUrl;
                }
            }, 1000)    
        }
    }
}
</script>


<style scoped>
    .pop-recom {
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .pop-recom .pop-body {
        width: 80%;
        height: 20%;
        background-color: #fbd3c6;
        border-radius: 18px;
        position: relative;
        text-align: center;
    }

    .pop-recom .pop-body .title{
        margin-top: 18px;
        font-size: 18px;
        font-weight: 600;
        color: #fb5e71;
    }

    .pop-recom .pop-body .content{
        margin-left: 10%;
        width: 80%;
        margin-top: 10px;
        font-size: 14px;
        line-height: 20px;
        color: #000;
    }

    .pop-recom .pop-body .button{
        margin-left: 30%;
        width: 40%;
        height: 30px;
        border-radius: 15px;
        margin-top: 18px;
        margin-bottom: 0px;
        font-size: 18px;
        line-height: 30px;
        color: #000;
        background-color: #e34032;
    }
    
    .pop-recom .img {
        width: 100%;
    }
    
    .pop-recom .btn-get {
        position: absolute;
        bottom: 100px;
        width: 60%;
        left: 20%;
        -webkit-animation: mymove .8s infinite;
    }

</style>



// WEBPACK FOOTER //
// RecomBox.vue?1ab1f0c9